import { useChatOrderStartModal } from 'hooks/useChatOrderStartModal';
import { useHoianUser } from 'hooks/useHoianUser';
import { useSelector } from 'react-redux';
import { StoreState } from 'store/ducks';

interface StartChatOrderButtonProps {
  baId: string;
  buyerId: string;
  text: string;
  isPrimary: boolean;
  onClick?: () => void;
}

const StartChatOrderButton = ({ baId, buyerId, text, isPrimary, onClick }: StartChatOrderButtonProps) => {
  const { nickname } = useHoianUser(buyerId);
  const channelId = useSelector((state: StoreState) => state.chatStore.selectChannelId);

  const { openChatOrderModal } = useChatOrderStartModal({
    baId,
    buyerId,
    buyerName: nickname ?? '(알 수 없음)',
    channelId,
  });

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onClick?.();
    openChatOrderModal();
  };

  return (
    <button
      className={`temp-button ${isPrimary ? 'primary' : ''}`}
      onClick={handleClick}
    >
      {text}
    </button>
  );
};

export default StartChatOrderButton;
